module.exports = __webpack_public_path__ + "img/person-skiing.399924ba.svg";